import { useEffect } from "react";

import type { ImagePost } from "@/react/types";

import { STEPS } from "../constants";
import { useImagePostModalStore } from "../store";
import type { NewPost } from "./usePost";

export const useInitializeStore = (
  post: ImagePost | NewPost | null,
  open: boolean,
) => {
  const { setCurrentStep, setUploadedImages } = useImagePostModalStore();
  const gallery = post?.gallery;

  useEffect(() => {
    if (!open) return;

    setCurrentStep(gallery ? STEPS.CREATE_POST : STEPS.UPLOAD_IMAGES);
    setUploadedImages(gallery?.images ?? []);
  }, [gallery, open, setCurrentStep, setUploadedImages]);
};
